module.exports = __webpack_public_path__ + "static/media/smart-profile.a9abfd3c.png";